module.exports = __webpack_public_path__ + "img/blog_cedric.8fb44236.gif";